import uniqueId from 'lodash/uniqueId'

import { ToastPayload } from '../../shared'
import * as actions from './toasterer.actions'

export interface State {
  toasts: ToastPayload[]
}

export const initialState: State = {
  toasts: [],
}

export const reducer = (state = initialState, action: actions.ToastererActions): State => {
  switch (action.type) {
    case actions.ADD_TOAST: {
      const newToast = {
        ...action.payload,
        id: uniqueId('toastr'),
      }

      return {
        ...state,
        toasts: [...state.toasts, newToast],
      }
    }

    case actions.REMOVE_TOAST: {
      const idToRemove = action.payload

      return {
        ...state,
        toasts: [
          ...state.toasts.reduce((acc: ToastPayload[], item: ToastPayload) => {
            if (item.id === idToRemove) return acc

            return [...acc, item]
          }, []),
        ],
      }
    }

    default:
      return state
  }
}

export const getToasts = (state: State) => state.toasts



// WEBPACK FOOTER //
// ./src/app/shared/store/toasterer.reducer.ts